import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable, catchError, map, of } from 'rxjs';

export interface VehicleDamagePart {
  id: string;
  name?: string;
  kind: 'path' | 'circle' | 'ellipse';
  tone: string;
  d?: string;
  cx?: number;
  cy?: number;
  r?: number;
  rx?: number;
  ry?: number;
}

export interface VehicleDamageViews {
  side: VehicleDamagePart[];
  front: VehicleDamagePart[];
  rear: VehicleDamagePart[];
}

@Injectable({
  providedIn: 'root'
})
export class VehicleDamageConfigService {
  private http = inject(HttpClient);

  // Obtiene las partes del vehículo desde API con fallback a assets
  getShapes(type: string): Observable<VehicleDamageViews> {
    const apiUrl = `${Global.url}V1/vehicles/damage-shapes/${type}`;
    const fallbackUrl = `assets/vehicle-diagrams/${type}/shapes.json`;
    return this.http.get<unknown>(apiUrl).pipe(
      catchError(() => this.http.get<unknown>(fallbackUrl)),
      catchError(() => of({ side: [], front: [], rear: [] })),
    ).pipe(
      // Acepta { side, front, rear } o un envoltorio { shapes | data }
      map(data => this._normalizeViews(data))
    );
  }

  private _normalizeViews(data: unknown): VehicleDamageViews {
    const raw = (data as { shapes?: unknown; data?: { shapes?: unknown } })?.shapes
      ?? (data as { data?: { shapes?: unknown } })?.data?.shapes
      ?? (data as { data?: unknown })?.data
      ?? data;
    const views = (raw ?? {}) as Partial<VehicleDamageViews>;
    return {
      side: Array.isArray(views.side) ? views.side : [],
      front: Array.isArray(views.front) ? views.front : [],
      rear: Array.isArray(views.rear) ? views.rear : []
    };
  }

  // Obtiene los recortes de fábrica directamente desde assets
  getDefaultShapes(type: string): Observable<VehicleDamageViews> {
    const fallbackUrl = `assets/vehicle-diagrams/${type}/shapes.json`;
    return this.http.get<VehicleDamageViews>(fallbackUrl);
  }

  // Guarda la configuración de partes en la base de datos
  saveShapes(type: string, data: VehicleDamageViews): Observable<any> {
    const url = `${Global.url}V1/vehicles/damage-shapes/${type}`;
    return this.http.put(url, data);
  }
}
